import { render, staticRenderFns } from "./warningForm.vue?vue&type=template&id=21c0c684"
import script from "./warningForm.vue?vue&type=script&lang=js"
export * from "./warningForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports